// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__37eU-","primary":"error_primary__PHKxu","secondary":"error_secondary__3qKuI","no_field_error":"error_no_field_error__16iyW"};